function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
import { useContext, useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import get from 'lodash/get';
import groupBy from 'lodash/groupBy';
import maxBy from 'lodash/maxBy';
import { ProfileContext } from 'context';
import { calculateRelatedData, getEndTimeTooltip, mergeDataIntoMeals, prepareMeasurements, translateMealsIntoChartData } from 'helpers/relatedData';
import MetricConversions from 'libs/MetricConversions';
import Account from 'modules/Account';
const prepareAdditionalData = ({ firstTick, lastTick, metricsUnits, measurements, relatedData, timeSeriesResources })=>{
    const measurementsWeights = [];
    const measurementsHeights = [];
    measurements.forEach((measurement)=>{
        switch(measurement.type){
            case 'Weight':
                measurementsWeights.push(measurement);
                break;
            case 'Height':
                measurementsHeights.push(measurement);
                break;
            default:
                break;
        }
    });
    const chartDiff = lastTick - firstTick;
    const pointMargins = chartDiff / 125;
    const newRelatedData = calculateRelatedData(relatedData, timeSeriesResources, firstTick, lastTick);
    const groupedActivities = groupBy(newRelatedData.activities, 'deviceDateTime');
    const groupedMedications = groupBy(newRelatedData.medications, 'deviceDateTime');
    newRelatedData.activities = [
        {
            id: 'activities',
            data: Object.keys(groupedActivities).map((timestamp)=>({
                    x: timestamp,
                    xEnd: maxBy(groupedActivities[timestamp], 'endTimestamp').endTimestamp,
                    y: 5,
                    relatedData: groupedActivities[timestamp]
                }))
        },
        {
            id: 'activities-end',
            data: Object.keys(groupedActivities).map((timestamp, index)=>({
                    xStart: timestamp,
                    x: getEndTimeTooltip(groupedActivities, timestamp, index, pointMargins),
                    y: 5,
                    relatedData: groupedActivities[timestamp],
                    endTimestamp: maxBy(groupedActivities[timestamp], 'endTimestamp').endTimestamp
                }))
        }
    ];
    newRelatedData.medications = [
        {
            id: 'medications',
            data: Object.keys(groupedMedications).map((timestamp)=>({
                    x: timestamp,
                    xEnd: maxBy(groupedMedications[timestamp], 'endTimestamp').endTimestamp,
                    y: 5,
                    relatedData: groupedMedications[timestamp]
                }))
        },
        {
            id: 'medications-end',
            data: Object.keys(groupedMedications).map((timestamp, index)=>({
                    xStart: timestamp,
                    x: getEndTimeTooltip(groupedMedications, timestamp, index, pointMargins),
                    y: 5,
                    relatedData: groupedMedications[timestamp],
                    endTimestamp: maxBy(groupedMedications[timestamp], 'endTimestamp').endTimestamp
                }))
        }
    ];
    const metricConversions = new MetricConversions(metricsUnits);
    const dataMeasurementsWeight = prepareMeasurements(measurementsWeights, 'weight', metricConversions, firstTick, lastTick, pointMargins);
    const dataMeasurementsHeight = prepareMeasurements(measurementsHeights, 'height', metricConversions, firstTick, lastTick, pointMargins);
    const newMeasurementsGrouped = {
        weight: null,
        height: null
    };
    newMeasurementsGrouped.weight = {
        id: 'weight',
        maxValue: get(maxBy(dataMeasurementsWeight, 'y'), 'y', 0),
        data: dataMeasurementsWeight
    };
    newMeasurementsGrouped.height = {
        id: 'height',
        maxValue: get(maxBy(dataMeasurementsHeight, 'y'), 'y', 0),
        data: dataMeasurementsHeight
    };
    // TODO: Implement TSR flow instead RelatedData flow
    const mealsRaw = mergeDataIntoMeals(relatedData, timeSeriesResources, firstTick).map((m)=>{
        if (m.nutritions) {
            var _m_nutritions_find, _m_nutritions_find1, _m_nutritions_find2, _m_nutritions_find3;
            return _object_spread_props(_object_spread({}, m), {
                carbs: (_m_nutritions_find = m.nutritions.find((nt)=>nt.type === 'Carbohydrates')) === null || _m_nutritions_find === void 0 ? void 0 : _m_nutritions_find.value,
                protein: (_m_nutritions_find1 = m.nutritions.find((nt)=>nt.type === 'Protein')) === null || _m_nutritions_find1 === void 0 ? void 0 : _m_nutritions_find1.value,
                energy: (_m_nutritions_find2 = m.nutritions.find((nt)=>nt.type === 'Energy')) === null || _m_nutritions_find2 === void 0 ? void 0 : _m_nutritions_find2.value,
                fat: (_m_nutritions_find3 = m.nutritions.find((nt)=>nt.type === 'FatTotal')) === null || _m_nutritions_find3 === void 0 ? void 0 : _m_nutritions_find3.value
            });
        }
        return m;
    });
    const newMeals = translateMealsIntoChartData(mealsRaw, firstTick);
    return {
        newMeasurementsGrouped,
        newRelatedDataGrouped: newRelatedData,
        newMeals
    };
};
export const useAdditionalData = (firstTick, lastTick)=>{
    const profileContext = useContext(ProfileContext);
    const measurements = useSelector(profileContext.selectors.measurements);
    const relatedData = useSelector(profileContext.selectors.relatedData);
    const timeSeriesResources = useSelector(profileContext.selectors.timeSeriesResources);
    const metricsUnits = useSelector(Account.selectors.metricsUnits);
    const [relatedDataGrouped, setRelatedDataGrouped] = useState({});
    const [measurementsGrouped, setMeasurementsGrouped] = useState({});
    const [meals, setMeals] = useState([]);
    useEffect(()=>{
        const { newMeasurementsGrouped, newRelatedDataGrouped, newMeals } = prepareAdditionalData({
            firstTick,
            lastTick,
            metricsUnits,
            measurements,
            relatedData,
            timeSeriesResources
        });
        setRelatedDataGrouped(newRelatedDataGrouped);
        setMeasurementsGrouped(newMeasurementsGrouped);
        setMeals(newMeals);
    }, [
        firstTick,
        lastTick,
        measurements,
        relatedData,
        timeSeriesResources
    ]);
    return {
        relatedDataGrouped,
        measurementsGrouped,
        meals
    };
};
